"use strict";

require("./minimum-version.modal.js");

angular.module("core").factory("MinimumVersionInterceptor", function($q, $injector, appConfig) {
    var allowed_url_regex = new RegExp("^" + appConfig.API_SERVER + "(?!/static/)");
    return {
        request: function(request) {

            if (window.app.app_version) {
                if (request.url.match(allowed_url_regex)) {
                    request.headers = request.headers || {};
                    request.headers["X-APP-VERSION"] = window.app.app_version;
                }
            }
            return request;
        },
        responseError: function(response) {
            if (response.status === 412) {
                var ModalService = $injector.get("ModalService");
                if (!window.minimum_version_modal_active) {
                    window.minimum_version_modal_active = true;
                    ModalService.showModal({
                        templateUrl: require("./minimum-version.modal.html"),
                        controller: "MinimumVersionController",
                        controllerAs: "MinimumVersionCtrl"
                    }).then(function(modal) {
                        modal.element.modal({
                            backdrop: "static",
                            keyboard: false
                        });
                        modal.element.on("hidden.bs.modal", function(e) {
                            modal.element.remove();
                        });
                        modal.close.then(function(result) {
                            modal.element.remove();
                        });
                    });
                }
            }
            return $q.reject(response);
        }
    };
})

.config(["$httpProvider", function($httpProvider) {
    $httpProvider.interceptors.push("MinimumVersionInterceptor");
}]);



//////////////////
// WEBPACK FOOTER
// ./core/minimum-version/minimum-version-interceptor.factory.js
// module id = 451
// module chunks = 0